import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function hasEnrollmentCenter(id: number, journeyId?: number) {
  return restApiClient
    .url(
      encodeNestedObject(constructApiUrl(API.centers.hasEnrollmentCenter.url, { id }), {
        journeyId
      })
    )
    .get<boolean>()
}
